/**
 * Prayer Times Service
 *
 * API service for fetching prayer times from the backend
 */

import { getApiClient } from './client';
import type { PrayerTimesResponse, NextPrayerResponse } from '@/types/prayer-times.types';

/**
 * Fetch all prayer times for the day
 *
 * @param masjidId - AthanPlus masjid ID (optional, uses default if not provided)
 * @returns Promise with prayer times data
 * @throws Error if request fails
 */
export async function getPrayerTimes(companyId: number): Promise<PrayerTimesResponse> {
  try {
    const apiClient = getApiClient();

    const response = await apiClient.get<PrayerTimesResponse>(`/prayer-times/${companyId}`);

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch prayer times: ${error.message}`);
    }
    throw error;
  }
}

/**
 * Fetch only the next upcoming prayer
 *
 * @param masjidId - AthanPlus masjid ID (optional, uses default if not provided)
 * @returns Promise with next prayer data
 * @throws Error if request fails
 */
export async function getNextPrayer(companyId: number): Promise<NextPrayerResponse> {
  try {
    const apiClient = getApiClient();

    const response = await apiClient.get<NextPrayerResponse>(`/prayer-times/${companyId}/next`);

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch next prayer: ${error.message}`);
    }
    throw error;
  }
}
